import { definePropType } from "@types-vue/props";
import { defineComponent, ref, watch } from "vue";
export default defineComponent({
    props: {
        options: {
            type: definePropType(Array),
            required: true
        },
        width: {
            type: Number,
            default: 280
        },
        defaultChecked: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props, root) {
        var handleApply = function handleApply() {
            backupList.value = checkedList.value;
            root.emit("apply", checkedList);
            popoverVisible.value = false;
        };
        var handleClearAll = function handleClearAll() {
            clearAll();
            root.emit("apply", checkedList);
        };
        var popoverVisible = ref(false);
        var checkedList = ref(props.defaultChecked);
        var backupList = ref(props.defaultChecked);
        var clearAll = function() {
            checkedList.value = [];
            backupList.value = [];
        };
        watch(function() {
            return popoverVisible.value;
        }, function(val) {
            if (!val) {
                checkedList.value = backupList.value;
            }
        }, {});
        // 如果在父组件传递响应式状态，则以父组件状态为准
        watch(function() {
            return props.defaultChecked;
        }, function(val) {
            checkedList.value = val;
        }, {});
        return {
            checkedList: checkedList,
            popoverVisible: popoverVisible,
            handleApply: handleApply,
            handleClearAll: handleClearAll,
            clearAll: clearAll
        };
    }
});
